module.exports = __webpack_public_path__ + "img/aParty_1208_D.df1e954d.jpg";